import React from 'react';
import { FormFieldProps } from '@nintendo/forms';
import { Field, FieldProps } from 'formik';
import MaskedInput from 'react-text-mask';
import createNumberMask from 'text-mask-addons/dist/createNumberMask';
import useFieldDecorators from '@nintendo/forms/lib/js/components/hooks/useFieldDecorators';

interface CurrencySearchFieldProps extends FormFieldProps {
    placeholder?: string;
}

const CurrencySearchField = (props: CurrencySearchFieldProps) => {
    const { contentCssClass, fieldCssClass } = useFieldDecorators(props);

    const { placeholder } = props;

    const currencyMask = createNumberMask({
        prefix: '', // we do not need to put '$' here since it is in the label already.
        suffix: '',
        includeThousandsSeparator: true,
        thousandsSeparatorSymbol: ',',
        allowDecimal: true,
        decimalSymbol: '.',
        decimalLimit: 2,
        allowNegative: true,
        allowLeadingZeroes: false,
    });

    return (
        <div className={contentCssClass}>
            <Field type="text" name={props.name}>
                {({ field, form }: FieldProps<FormFieldProps>) => (
                    <MaskedInput
                        id={props.name}
                        name={field.name}
                        className={`${fieldCssClass} ${field.value ? 'text-right' : ''}`}
                        checked={field.checked}
                        multiple={field.multiple}
                        data-testid={props.testId}
                        mask={currencyMask}
                        onChange={(e) => {
                            const targetValue = e.target.value.replace(/,/g, ''); // to remove the comma, which is the only thing left after the mask
                            form.setFieldValue(props.name, targetValue);
                        }}
                        onBlur={field.onBlur}
                        onFocus={(e) => {
                            e.target.select();
                        }}
                        placeholder={placeholder}
                        value={field.value ? field.value.toString() : undefined}
                    />
                )}
            </Field>
        </div>
    );
};

export default CurrencySearchField;
